// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import './services/filters'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VeeValidate from 'vee-validate'
import Admin from './components/layouts/admin.vue'
import Guest from './components/layouts/guest.vue'
import Simple from './components/layouts/simple.vue'
import Default from './components/layouts/default.vue'

const fb = require('./services/firebase.js')
require('vue2-animate/dist/vue2-animate.min.css')

// Vue.use(VueFire)
Vue.use(VeeValidate)
Vue.component('admin-layout', Admin)
Vue.component('guest-layout', Guest)
Vue.component('simple-layout', Simple)
Vue.component('default-layout', Default)

Vue.use(Vuetify, {
  theme: {
    primary: '#0F7143',
    secondary: '#3BBB51',
    accent: '#F8E382',
    error: '#FFAB00'
  }
})
Vue.config.productionTip = false

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   store,
//   template: '<App/>',
//   components: { App },
//   beforeCreate () {
//     store.dispatch('fetchUser')
//   }
// })
// handle page reloads
let app
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: { App },
      data () {
        return {
          windowWidth: ''
        }
      },
      created () {
        // handle page reload
        fb.auth.onAuthStateChanged(user => {
          if (user) {
            store.dispatch('setCurrentUser', user.uid)
            store.dispatch('fetchUserProfile', user.uid)
          }
        })
      },
      mounted () {
        this.$nextTick(() => {
          this.windowWidth = window.innerWidth
          window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
          })
        })
        if (!localStorage.getItem('measureSystem')) {
          var measureSystem = {
            length: 'cm', weight: 'kgs'
          }
          localStorage.setItem('measureSystem', JSON.stringify(measureSystem))
        }
        if (JSON.parse(localStorage.getItem('measureSystem'))) {
          var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
          var newMeasureSystem = {
            length: 'cm', weight: 'kgs'
          }
          if (localMeasureSystem.weight === 'kilos') {
            localStorage.setItem('measureSystem', JSON.stringify(newMeasureSystem))
          }
        }
        if (!localStorage.getItem('weightHint')) {
          localStorage.setItem('weightHint', JSON.stringify(true))
        }
        this.$validator.localize('en', {
          messages: {
            numeric: (field) => 'Must only contain numeric characters'
          },
          attributes: {
            email: 'Email'
          }
        })
      },
      computed: {
        isTouch () {
          if (this.windowWidth <= 960) {
            return true
          } return false
        }
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js